import { render } from "./vdmDetail.vue?vue&type=template&id=062b01d3&scoped=true"
import script from "./vdmDetail.vue?vue&type=script&lang=js"
export * from "./vdmDetail.vue?vue&type=script&lang=js"

import "./vdmDetail.vue?vue&type=style&index=0&id=062b01d3&lang=scss&scoped=true"
import "./vdmDetail.vue?vue&type=style&index=1&id=062b01d3&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062b01d3"]])

export default __exports__